import React from 'react';
import styled from 'styled-components/macro';
import { Typography } from 'antd';
import { OwnershipList } from './OwnershipList';
import { useTranslation } from '../../../i18n/useTranslation';

const PageContainer = styled.div`
    padding-top: 20px;
    width: 100%;
`;

const PageHeaderContainer = styled.div`
    && {
        padding-left: 24px;
    }
`;

const PageTitle = styled(Typography.Title)`
    && {
        margin-bottom: 12px;
    }
`;

const ListContainer = styled.div``;

/**
 * Component used for displaying the 'Manage Ownership' experience.
 */
export const ManageOwnership = () => {
    const { t } = useTranslation();

    return (
        <PageContainer>
            <PageHeaderContainer>
                <PageTitle level={3}>{t('Manage Ownership')}</PageTitle>
                <Typography.Paragraph type="secondary">
                    {t('CREATE_EDIT_REMOVE_OWNERSHIP_TYPES_DESC')}
                </Typography.Paragraph>
            </PageHeaderContainer>
            <ListContainer>
                <OwnershipList />
            </ListContainer>
        </PageContainer>
    );
};
